<template>
  <div class="tabs-container">
    <DxTabs :data-source="visibleTabs" :selected-index.sync="selectedIndex" @option-changed="onTabChanged"
      :item-template="tabTemplate" orientation="horizontal" />
    <template v-for="(t, i) in visibleTabs" :key="t.modul">
      <div v-if="selectedIndex === i">
        <component :is="t.component" />
      </div>
    </template>
  </div>
</template>
<script>
import { DxTabs } from 'devextreme-vue/tabs';
import NomenclatoareCRM from '../Comercial/CRM/NomenclatoareCRM.vue';
import NomenclatoareResurseUmane from '../ResurseUmane/NomenclatoareResurseUmane.vue';
import NomenclatoareParcAuto from '../ParcAuto/Nomenclatoare/NomenclatoareParcAuto.vue';
import CompanyServices from '@/services/CompanyService';

export default {
  components: {
    NomenclatoareCRM,
    DxTabs,
    NomenclatoareResurseUmane,
    NomenclatoareParcAuto,
  },
  data() {
    return {
      // fiecare tab e legat de numele modulului (AUTH_DrepturiModule.Nume)
      allTabs: [
        { text: 'CRM', modul: 'CRM', component: 'NomenclatoareCRM' },
        { text: 'Resurse Umane', modul: 'Resurse Umane', component: 'NomenclatoareResurseUmane' },
        { text: 'Parc Auto', modul: 'Parc Auto', component: 'NomenclatoareParcAuto' },
      ],
      // null = necunoscut inca / eroare -> aratam tot (nu blocam);
      // array -> filtram taburile la modulele accesibile userului
      accessible: null,
      selectedIndex: 0,
    };
  },
  computed: {
    visibleTabs() {
      if (!this.accessible) return this.allTabs;
      return this.allTabs.filter((t) => this.accessible.includes(t.modul));
    },
  },
  methods: {
    onTabChanged(e) {
      this.selectedIndex = e.component.option('selectedIndex');

      this.$router.replace({
        query: {
          ...this.$route.query,
          mainTab: this.selectedIndex
        }
      }).catch(() => { })
    },
    tabTemplate(itemData, itemIndex, itemElement) {
      return `<div>${itemData.text}</div>`;
    },
  },
  async mounted() {
    try {
      const r = await CompanyServices.getModuleAccess();
      this.accessible = r.data?.Accessible || [];
    } catch {
      this.accessible = null; // la eroare, comportament vechi (arata tot)
    }
    const idx = Number(this.$route.query.mainTab);
    this.selectedIndex = !isNaN(idx) && idx < this.visibleTabs.length ? idx : 0;
  }
};
</script>
<style scoped></style>
